
//src/assets/scripts/top/page.js
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper';
import 'swiper/css';
import "swiper/css/scrollbar";
import { Autoplay, Scrollbar, Mousewheel, Navigation, FreeMode } from "swiper/modules";


export default class PageJS {
    constructor(common) {
        this.common = common;
    }

    init() {
        
       
        
        this.common.init();//common.jsはここでinitさせる

    }

    getAssetPath(relative) {
        const hostname = window.location.hostname;
        const isLocal =
            hostname === 'localhost' ||
            hostname === '127.0.0.1' ||
            hostname.endsWith('.local');
        if (isLocal) {
            return `/dist/assets/images/${relative}`;
        } else {
            return `/wp/wp-content/themes/theme-villamom/dist/assets/images/${relative}`;
        }
    }


  
    

}
